// TypeScript Interfaces für Zulassungsantrag basierend auf Fachkonzept

import { Fahrzeug } from './fahrzeug';
import { Halter } from './halter';
export interface Zulassungsantrag {
  // Allgemeine Antragsdaten
  gkIdZulB: string;                    // ID des GK bei der ZulB (obligatorisch)
  fin: string;                         // FIN (obligatorisch)
  kennzeichen: string;                 // Kennzeichen (obligatorisch)
  kennzeichenart?: string;             // Kennzeichenart (fakultativ)
  reservierungsnummer?: string;        // Reservierungsnummer (PIN) für Kennzeichen (fakultativ)
  elektrokennzeichen?: boolean;        // Merkmal Elektrokennzeichen (fakultativ)
  feinstaubplakette?: boolean;         // Merkmal Feinstaubplakette gewünscht (fakultativ)
  zbIINummer: string;                  // Nummer der ZB II (obligatorisch)
  zbIISicherheitscode: string;         // Sicherheitscode der ZB II (obligatorisch)
  vbNummer: string;                    // VB-Nummer (obligatorisch)
  verwendungszweck?: string;           // Verwendungszweck (fakultativ)
  berufsschluessel: string;            // Berufsschlüssel (Wirtschaftszweig) - Obligatorisch für jP

  // HU-Nachweis
  huMonatJahr?: string;                // Monat und Jahr der nächsten HU (fakultativ)
  huPruefziffer?: string;              // HU-Prüfziffer (fakultativ)
  huDatumUntersuchung?: string;        // Datum der Untersuchung (fakultativ)
  huUeberwachungsorganisation?: string; // Nummer der Überwachungsorganisation (ÜI) (fakultativ)

  // Alternative Versandadresse (für Zulassungsdokumente)
  versandVorname?: string;             // Vorname (fakultativ)
  versandName: string;                 // Familienname / Name jur. Person (obligatorisch)
  versandStrasse: string;              // Straße (obligatorisch)
  versandHausnummer: string;           // Hausnummer (obligatorisch)
  versandAdressierungszusaetze?: string; // Adressierungszusätze (fakultativ)
  versandPostleitzahl: string;         // Postleitzahl (obligatorisch)
  versandOrt: string;                  // Ort (obligatorisch)

  // Zusätzliche Felder für interne Verwaltung
  kundeId: number;                     // Zuordnung zum Kunden
  status?: string;                     // Status des Antrags
}

export interface ZulassungsantragFormData {
  // Geschäftsvorfall
  geschaeftsvorfallTyp: string;        // Art des Geschäftsvorfalls (obligatorisch)
  antragstellerTyp?: string;           // EIGENE_PERSON oder DRITTE_PERSON
  
  // Halterdaten
  halterTyp: string;                   // 'natuerlich' | 'juristisch'
  vorname: string;                     // Vorname des Halters
  nachname: string;                    // Nachname des Halters
  geburtstag?: string;                 // Geburtstag (fakultativ)
  geburtsort?: string;                 // Geburtsort (fakultativ)
  email?: string;                      // E-Mail (fakultativ)
  telefonnummer?: string;              // Telefonnummer (fakultativ)

  // Fahrzeugdaten
  fahrzeugTyp: string;                 // 'auto' | 'motorrad' | 'traktor'
  fin: string;                         // FIN (obligatorisch)
  zbIINummer: string;                  // Nummer der ZB II (obligatorisch)
  zbIISicherheitscode: string;         // Sicherheitscode der ZB II (obligatorisch)
  briefnummer?: string;                // Briefnummer (fakultativ)
  zbIISicherheitscodeZB2?: string;     // Sicherheitscode ZB2 (fakultativ)
  evb?: string;                        // eVB (fakultativ)
  alteKennzeichenStadt?: string;       // Alte Kennzeichen - Stadtbuchstaben
  alteKennzeichenBuchstaben?: string;  // Alte Kennzeichen - Buchstaben
  alteKennzeichenNummern?: string;     // Alte Kennzeichen - Nummern
  neueKennzeichenStadt?: string;       // Neue Kennzeichen - Stadtbuchstaben
  neueKennzeichenBuchstaben?: string;  // Neue Kennzeichen - Buchstaben
  neueKennzeichenNummern?: string;     // Neue Kennzeichen - Nummern
  sonderkennzeichen?: string;          // 'H' | 'E' | ''
  reservierungsPin?: string;           // PIN der Reservierung
  saisonkennzeichen?: boolean;         // Saisonkennzeichen
  saisonVon?: string;                  // Saison von (Monat)
  saisonBis?: string;                  // Saison bis (Monat)

  // Bankverbindung
  zulassungsstelle: string;            // Zulassungsstelle (obligatorisch)
  datumZulassung?: string;             // Datum der Zulassung
  iban?: string;                        // IBAN (obligatorisch)
  bic?: string;                        // BIC (fakultativ)
  bankName?: string;                    // Name Kontoinhaber (obligatorisch)
  bankVorname?: string;                // Vorname Kontoinhaber (fakultativ)

  // Alte Felder für Kompatibilität
  gkIdZulB: string;                    // ID des GK bei der ZulB (obligatorisch)
  kennzeichen: string;                 // Kennzeichen (obligatorisch)
  kennzeichenart?: string;             // Kennzeichenart (fakultativ)
  reservierungsnummer?: string;        // Reservierungsnummer (PIN) für Kennzeichen (fakultativ)
  elektrokennzeichen?: boolean;        // Merkmal Elektrokennzeichen (fakultativ)
  feinstaubplakette?: boolean;         // Merkmal Feinstaubplakette gewünscht (fakultativ)
  vbNummer: string;                    // VB-Nummer (obligatorisch)
  verwendungszweck?: string;           // Verwendungszweck (fakultativ)
  berufsschluessel: string;            // Berufsschlüssel (Wirtschaftszweig) - Obligatorisch für jP

  // HU-Nachweis
  huMonatJahr?: string;                // Monat und Jahr der nächsten HU (fakultativ)
  huPruefziffer?: string;              // HU-Prüfziffer (fakultativ)
  huDatumUntersuchung?: string;        // Datum der Untersuchung (fakultativ)
  huUeberwachungsorganisation?: string; // Nummer der Überwachungsorganisation (ÜI) (fakultativ)

  // Alternative Versandadresse (für Zulassungsdokumente)
  versandVorname?: string;             // Vorname (fakultativ)
  versandName: string;                 // Familienname / Name jur. Person (obligatorisch)
  versandStrasse: string;              // Straße (obligatorisch)
  versandHausnummer: string;           // Hausnummer (obligatorisch)
  versandAdressierungszusaetze?: string; // Adressierungszusätze (fakultativ)
  versandPostleitzahl: string;         // Postleitzahl (obligatorisch)
  versandOrt: string;                  // Ort (obligatorisch)

  // Zusätzliche Felder für interne Verwaltung
  kundeId: number;                     // Zuordnung zum Kunden
  nutzerId?: number;                   // Zuordnung zum Nutzer
  kundenNummer?: string;               // Kundennummer
  status?: string;                     // Status des Antrags
}

export interface ZulassungsantragCreateRequest {
  // JSON-basierte API-Kommunikation
  nachrichtenId: string;
  kunde: { id: number };               // Kunde Objekt mit ID (obligatorisch)
  nutzer: { id: number };              // Nutzer Objekt mit ID (obligatorisch)
  halter?: { id: number };             // Halter Objekt mit ID (fakultativ)
  fahrzeug?: { id: number };           // Fahrzeug Objekt mit ID (fakultativ)
  status: string;
  geschaeftsvorfallTyp: string;
  antragstellerTyp?: string;           // EIGENE_PERSON oder DRITTE_PERSON
  prioritaet?: string;
  
  // Halterdaten
  halterTyp: string;
  vorname: string;
  nachname: string;
  geburtstag?: string;
  geburtsort?: string;
  email?: string;
  telefonnummer?: string;

  // Fahrzeugdaten
  fahrzeugTyp: string;
  fin: string;
  zbIINummer: string;
  zbIISicherheitscode: string;
  reservierungsPin?: string;
  kennzeichenart?: string;
  elektrokennzeichen?: boolean;
  feinstaubplakette?: boolean;

  // Bankverbindung
  zulassungsstelle: string;
  iban: string;
  bic?: string;
  bankName: string;
  bankVorname?: string;

  // HU-Nachweis
  huMonatJahr?: string;
  huPruefziffer?: string;
  huDatumUntersuchung?: string;
  huUeberwachungsorganisation?: string;

  // Versandadresse
  versandVorname?: string;
  versandName: string;
  versandStrasse: string;
  versandHausnummer: string;
  versandAdressierungszusaetze?: string;
  versandPostleitzahl: string;
  versandOrt: string;
}

// Vereinfachte Struktur für den Listen-Endpoint GET /api/zulassungsantraege
export interface ZulassungsantragListItem {
  id: number;
  nachrichtenId: string;
  geschaeftsvorfallTyp: string;
  status: string;
  prioritaet: string | null;
  erstelltAm: string;
  gesendetAm: string | null;
  abgeschlossenAm: string | null;
  kundeId: number;
  nutzerId: number;
  vorgangsId: string | null;
  customerNumber: string | null;
  vin: string | null;
  halterName: string | null;
  fin: string | null;
  neuesKennzeichen: string | null;
  altesKennzeichen: string | null;
}

export interface ZulassungsantragResponse {
  id: number;
  nachrichtenId: string;
  status: string;
  geschaeftsvorfallTyp: string;
  antragstellerTyp?: string;  // EIGENE_PERSON oder DRITTE_PERSON
  kunde: {
    id: number;
    name: string;
    kundenNummer: string;
  };
  nutzer?: {
    id: number;
    username: string;
  };
  fahrzeug: Fahrzeug;
  halter: Halter;
  erstelltAm: string;
  aktualisiertAm: string;
  
  // Alle Formulardaten als JSON
  halterTyp: string;
  vorname: string;
  nachname: string;
  geburtstag?: string;
  geburtsort?: string;
  email?: string;
  telefonnummer?: string;
  fahrzeugTyp: string;
  fin: string;
  zbIINummer: string;
  zbIISicherheitscode: string;
  reservierungsPin?: string;
  kennzeichenart?: string;
  elektrokennzeichen?: boolean;
  feinstaubplakette?: boolean;
  zulassungsstelle: string;
  iban: string;
  bic?: string;
  bankName: string;
  bankVorname?: string;
  huMonatJahr?: string;
  huPruefziffer?: string;
  huDatumUntersuchung?: string;
  huUeberwachungsorganisation?: string;
  versandVorname?: string;
  versandName: string;
  versandStrasse: string;
  versandHausnummer: string;
  versandAdressierungszusaetze?: string;
  versandPostleitzahl: string;
  versandOrt: string;
  
  // Fahrzeugbezogene Kennzeichenreservierung (nur bei Außerbetriebsetzung)
  kennzeichenReservierung?: boolean;
  
  // Ablehnungsgrund bei Status ABGELEHNT (Semikolon-getrennte Fehlermeldungen)
  ablehnungsgrund?: string;
}

// Enums für Dropdown-Werte
export enum Kennzeichenart {
  STANDARD = "STANDARD",
  SAISON = "SAISON",
  KURZZEITKENNZEICHEN = "KURZZEITKENNZEICHEN",
  AUSFUHRKENNZEICHEN = "AUSFUHRKENNZEICHEN",
  ROTE_KENNZEICHEN = "ROTE_KENNZEICHEN"
}

export enum GeschaeftsvorfallTyp {
  /** NZ - Neuzulassung */
  NEUZULASSUNG = "NEUZULASSUNG",
  
  /** UO - Umschreibung aus einem anderen Zulassungsbezirk ohne Halterwechsel */
  UMSCHREIBUNG_ANDERER_BEZIRK_OHNE_HALTERWECHSEL = "UMSCHREIBUNG_ANDERER_BEZIRK_OHNE_HALTERWECHSEL",
  
  /** UM - Umschreibung aus einem anderen Zulassungsbezirk mit Halterwechsel */
  UMSCHREIBUNG_ANDERER_BEZIRK_MIT_HALTERWECHSEL = "UMSCHREIBUNG_ANDERER_BEZIRK_MIT_HALTERWECHSEL",
  
  /** UI - Umschreibung innerhalb mit Halterwechsel */
  UMSCHREIBUNG_INNERHALB_MIT_HALTERWECHSEL = "UMSCHREIBUNG_INNERHALB_MIT_HALTERWECHSEL",
  
  /** AB - Außerbetriebsetzung */
  AUSSERBETRIEBSETZUNG = "AUSSERBETRIEBSETZUNG",
  
  /** WZ - Wiederzulassung für den selben Halter wie vor der Abmeldung */
  WIEDERZULASSUNG_SELBER_HALTER = "WIEDERZULASSUNG_SELBER_HALTER",
  
  /** WG - Wiederzulassung eines außer Betrieb gesetzten Fahrzeugs über GKS */
  WIEDERZULASSUNG = "WIEDERZULASSUNG",
  
  /** HA - Adress- bzw. Halteränderung */
  AENDERUNG_HALTERDATEN = "AENDERUNG_HALTERDATEN"
}

// Helper-Funktion für benutzerfreundliche Anzeige
export const getGeschaeftsvorfallTypLabel = (typ: string): string => {
  const labels: Record<string, string> = {
    'NEUZULASSUNG': 'Neuzulassung',
    'UMSCHREIBUNG_ANDERER_BEZIRK_OHNE_HALTERWECHSEL': 'Umschreibung ohne Halterwechsel',
    'UMSCHREIBUNG_ANDERER_BEZIRK_MIT_HALTERWECHSEL': 'Umschreibung mit Halterwechsel',
    'UMSCHREIBUNG_INNERHALB_MIT_HALTERWECHSEL': 'Umschreibung innerhalb',
    'AUSSERBETRIEBSETZUNG': 'Außerbetriebsetzung',
    'WIEDERZULASSUNG_SELBER_HALTER': 'Wiederzulassung (selber Halter)',
    'WIEDERZULASSUNG': 'Wiederzulassung',
    'AENDERUNG_HALTERDATEN': 'Halteränderung',
    
    // Legacy-Werte für Rückwärtskompatibilität
    
  };
  
  return labels[typ] || typ;
};

// Interface für Sichtbarkeit von Komponenten basierend auf Geschäftsvorfalltyp
export interface ComponentVisibility {
  bankverbindung: boolean;
  vollmacht: boolean;
  sepaMandat: boolean;
  hauptuntersuchung: boolean;
  feinstaubplakette: boolean;
  versicherungsbestaetigung: boolean;
  halter: boolean;
  kennzeichen: boolean;
  fahrzeug: boolean;
  versandadresse: boolean;
}

// Erweiterte Sichtbarkeit für Formularfelder basierend auf Geschäftsvorfalltyp UND Antragstellertyp
export interface FieldVisibility {
  // Fahrzeugdaten
  fin: boolean;
  zb1: boolean;           // ZB1 Nummer + Sicherheitscode
  zb2: boolean;           // ZB2 Nummer + Sicherheitscode
  altesKennzeichen: boolean;
  neuesKennzeichen: boolean;
  verwendungszweck: boolean;
  
  // Halter
  halter: boolean;
  
  // Dokumente & Finanzen
  bankverbindung: boolean;
  vollmacht: boolean;
  sepaMandat: boolean;
  versicherung: boolean;  // eVB
  
  // Sonstiges
  kennzeichenReservierung: boolean;
  verwertungsnachweis: boolean;
}

// Helper-Funktion: Welche Felder sind für welchen Geschäftsvorfalltyp + Antragstellertyp erforderlich
export const getFieldVisibility = (geschaeftsvorfallTyp: string, antragstellerTyp?: string): FieldVisibility => {
  const isAufDritte = antragstellerTyp === 'DRITTE_PERSON';
  
  // Prüfen ob Umschreibung
  const isUmschreibung = geschaeftsvorfallTyp === 'UMSCHREIBUNG_ANDERER_BEZIRK_OHNE_HALTERWECHSEL' ||
                         geschaeftsvorfallTyp === 'UMSCHREIBUNG_ANDERER_BEZIRK_MIT_HALTERWECHSEL' ||
                         geschaeftsvorfallTyp === 'UMSCHREIBUNG_INNERHALB_MIT_HALTERWECHSEL';

  switch (geschaeftsvorfallTyp) {
    // 1. Außerbetriebsetzung - kein Unterschied zwischen auf sich selbst/auf Dritte
    case 'AUSSERBETRIEBSETZUNG':
      return {
        fin: true,
        zb1: true,
        zb2: true,  // optional, aber anzeigen
        altesKennzeichen: true,
        neuesKennzeichen: false,
        verwendungszweck: false,
        halter: false,
        bankverbindung: false,
        vollmacht: false,
        sepaMandat: false,
        versicherung: false,
        kennzeichenReservierung: true,
        verwertungsnachweis: true
      };

    // 2. & 3. Neuzulassung
    case 'NEUZULASSUNG':
      if (isAufDritte) {
        // 3. Neuzulassung auf Dritte
        return {
          fin: true,
          zb1: false,
          zb2: true,
          altesKennzeichen: false,
          neuesKennzeichen: true,
          verwendungszweck: true,
          halter: true,
          bankverbindung: true,
          vollmacht: true,
          sepaMandat: true,
          versicherung: true,
          kennzeichenReservierung: false,
          verwertungsnachweis: false
        };
      } else {
        // 2. Neuzulassung auf sich selbst
        return {
          fin: true,
          zb1: false,
          zb2: true,
          altesKennzeichen: false,
          neuesKennzeichen: true,
          verwendungszweck: true,
          halter: false,
          bankverbindung: false,
          vollmacht: false,
          sepaMandat: false,
          versicherung: true,
          kennzeichenReservierung: false,
          verwertungsnachweis: false
        };
      }

    // 4. Wiederzulassung selber Halter (WZ) - Halter und Bankverbindung sind Pflicht (wie bei WIEDERZULASSUNG)
    case 'WIEDERZULASSUNG_SELBER_HALTER':
      return {
        fin: true,
        zb1: true,
        zb2: true,
        altesKennzeichen: true,
        neuesKennzeichen: true,
        verwendungszweck: true,
        halter: true,
        bankverbindung: true,
        vollmacht: isAufDritte,
        sepaMandat: isAufDritte,
        versicherung: true,
        kennzeichenReservierung: false,
        verwertungsnachweis: false
      };

    // 5. & 6. Wiederzulassung (WG) - allgemeine Wiederzulassung über GKS
    case 'WIEDERZULASSUNG':
      if (isAufDritte) {
        // 6. Wiederzulassung auf Dritte
        return {
          fin: true,
          zb1: true,
          zb2: true,
          altesKennzeichen: true,
          neuesKennzeichen: true,
          verwendungszweck: true,
          halter: true,
          bankverbindung: true,
          vollmacht: true,
          sepaMandat: true,
          versicherung: true,
          kennzeichenReservierung: false,
          verwertungsnachweis: false
        };
      } else {
        // 5. Wiederzulassung auf sich selbst
        return {
          fin: true,
          zb1: true,
          zb2: true,
          altesKennzeichen: true,
          neuesKennzeichen: true,
          verwendungszweck: true,
          halter: false,
          bankverbindung: false,
          vollmacht: false,
          sepaMandat: false,
          versicherung: true,
          kennzeichenReservierung: false,
          verwertungsnachweis: false
        };
      }

    // 6. & 7. Umschreibung
    case 'UMSCHREIBUNG_ANDERER_BEZIRK_OHNE_HALTERWECHSEL':
    case 'UMSCHREIBUNG_ANDERER_BEZIRK_MIT_HALTERWECHSEL':
    case 'UMSCHREIBUNG_INNERHALB_MIT_HALTERWECHSEL':
      if (isAufDritte) {
        // 7. Umschreibung auf Dritte
        return {
          fin: true,
          zb1: true,
          zb2: true,
          altesKennzeichen: true,
          neuesKennzeichen: true,
          verwendungszweck: true,
          halter: true,
          bankverbindung: true,
          vollmacht: true,
          sepaMandat: true,
          versicherung: true,
          kennzeichenReservierung: false,
          verwertungsnachweis: false
        };
      } else {
        // 6. Umschreibung auf sich selbst
        return {
          fin: true,
          zb1: true,
          zb2: true,
          altesKennzeichen: true,
          neuesKennzeichen: true,
          verwendungszweck: true,
          halter: false,
          bankverbindung: false,
          vollmacht: false,
          sepaMandat: false,
          versicherung: true,
          kennzeichenReservierung: false,
          verwertungsnachweis: false
        };
      }

    // 8. & 9. Halteränderung
    case 'AENDERUNG_HALTERDATEN':
      if (isAufDritte) {
        // 9. Halteränderung auf Dritte
        return {
          fin: true,
          zb1: true,
          zb2: false,
          altesKennzeichen: true,
          neuesKennzeichen: false,
          verwendungszweck: false,
          halter: true,
          bankverbindung: false,
          vollmacht: true,
          sepaMandat: false,
          versicherung: false,
          kennzeichenReservierung: false,
          verwertungsnachweis: false
        };
      } else {
        // 8. Halteränderung auf sich selbst
        return {
          fin: true,
          zb1: true,
          zb2: false,
          altesKennzeichen: true,
          neuesKennzeichen: false,
          verwendungszweck: false,
          halter: false,
          bankverbindung: false,
          vollmacht: false,
          sepaMandat: false,
          versicherung: false,
          kennzeichenReservierung: false,
          verwertungsnachweis: false
        };
      }

    default:
      // Unbekannter Typ: Alles anzeigen
      return {
        fin: true,
        zb1: true,
        zb2: true,
        altesKennzeichen: true,
        neuesKennzeichen: true,
        verwendungszweck: true,
        halter: true,
        bankverbindung: true,
        vollmacht: true,
        sepaMandat: true,
        versicherung: true,
        kennzeichenReservierung: true,
        verwertungsnachweis: true
      };
  }
};

// Helper-Funktion: Welche Komponenten sind für welchen Geschäftsvorfalltyp erforderlich
// Basiert auf GrundaufbauAntragNachricht.md - Elemente mit "G" (vom Großkunden angeliefert)
export const getComponentVisibility = (geschaeftsvorfallTyp: string): ComponentVisibility => {

  // Standard: Alle anzeigen
  const defaultVisibility: ComponentVisibility = {
    bankverbindung: true,
    vollmacht: true,
    sepaMandat: true,
    hauptuntersuchung: true,
    feinstaubplakette: true,
    versicherungsbestaetigung: true,
    halter: true,
    kennzeichen: true,
    fahrzeug: true,
    versandadresse: true
  };

  const normalizedTyp = geschaeftsvorfallTyp?.toUpperCase() || '';

  switch (normalizedTyp) {
    case 'NEUZULASSUNG':
      return {
        ...defaultVisibility,
        // Alles erforderlich für Neuzulassung
        bankverbindung: true,
        vollmacht: true,
        sepaMandat: true,
        versicherungsbestaetigung: true,
        halter: true,
        kennzeichen: true,
        fahrzeug: true,
        hauptuntersuchung: true,
        feinstaubplakette: true,
        versandadresse: true
      };

    case 'AUSSERBETRIEBSETZUNG':
      return {
        ...defaultVisibility,
        // Bei Außerbetriebsetzung: KEINE Bankverbindung, KEINE Vollmacht, KEIN SEPA
        bankverbindung: false,
        vollmacht: false,
        sepaMandat: false,
        versicherungsbestaetigung: false,
        feinstaubplakette: false,
        halter: false, // identifikation - Halter: P (wird vom Portal eingegeben, nicht vom GK)
        kennzeichen: true,
        fahrzeug: true,
        hauptuntersuchung: false,
        versandadresse: false
      };

    case 'AENDERUNG_HALTERDATEN':
      return {
        ...defaultVisibility,
        // Halteränderung: KEINE Bankverbindung, KEIN SEPA
        bankverbindung: false,
        vollmacht: true,
        sepaMandat: false,
        versicherungsbestaetigung: false,
        feinstaubplakette: false,
        halter: true,
        kennzeichen: true,
        fahrzeug: true,
        hauptuntersuchung: true,
        versandadresse: true
      };

    case 'UMSCHREIBUNG_ANDERER_BEZIRK_MIT_HALTERWECHSEL':
    case 'UMSCHREIBUNG_ANDERER_BEZIRK_OHNE_HALTERWECHSEL':
    case 'UMSCHREIBUNG_INNERHALB_MIT_HALTERWECHSEL':
    case 'WIEDERZULASSUNG':
    case 'WIEDERZULASSUNG_SELBER_HALTER':
      return {
        ...defaultVisibility,
        // Umschreibungen und Wiederzulassung: Alles erforderlich
        bankverbindung: true,
        vollmacht: true,
        sepaMandat: true,
        versicherungsbestaetigung: true,
        halter: true,
        kennzeichen: true,
        fahrzeug: true,
        hauptuntersuchung: true,
        feinstaubplakette: true,
        versandadresse: true
      };

    default:
      // Unbekannter Typ: Alles anzeigen
      return defaultVisibility;
  }
};

// Antragsteller-Typ: Wer stellt den Antrag?
export enum AntragstellerTyp {
  /** Zulassung auf sich selbst */
  EIGENE_PERSON = "EIGENE_PERSON",
  /** Zulassung auf Dritte */
  DRITTE_PERSON = "DRITTE_PERSON"
}

// Helper-Funktion für benutzerfreundliche Anzeige des Antragstellertyps
export const getAntragstellerTypLabel = (typ: string): string => {
  const labels: Record<string, string> = {
    'EIGENE_PERSON': 'Auf sich selbst',
    'DRITTE_PERSON': 'Auf Dritte'
  };
  return labels[typ] || typ;
};

// Status-Werte entsprechend der Backend-API
export enum AntragStatus {
  ERSTELLT = "ERSTELLT",                           // Entwurf/Neu erstellt
  GESENDET = "GESENDET",                           // Eingereicht/Gesendet
  IN_BEARBEITUNG = "IN_BEARBEITUNG",               // In Bearbeitung
  GEPRUEFT = "GEPRUEFT",                           // Geprüft
  ABGESCHLOSSEN = "ABGESCHLOSSEN",                 // Abgeschlossen
  ABGELEHNT = "ABGELEHNT",                         // Abgelehnt
  FEHLER = "FEHLER"                                // Fehler
}

// KBA-Quittung Ergebnis (kommunikation.quittung.0002)
export interface GksQuittungResult {
  success: boolean;
  antragsnummer?: string;
  zustaendigerKommunikationspartner?: string;
  quittungsCodes: QuittungsCode[];
  fehlerMeldungen: string[];
}

export interface QuittungsCode {
  code: string;
  text?: string;
  quittungsart?: number; // 0 = OK, 2 = Fehler
}

// KBA-Statusabfrage Ergebnis (vorsystem.status.0706)
export interface StatusAbfrageResult {
  antragId: number;
  kbaAntragsnummer?: string;
  status: string;
  kbaStatus?: string;
  statusBeschreibung?: string;
  neuerStatus?: string;
  fehlerMeldung?: string;
}

// Submit-Ergebnis mit Quittung
export interface SubmitResult {
  antrag: ZulassungsantragResponse;
  quittung?: GksQuittungResult;
}

// Validierungsregeln
export interface FormValidation {
  field: keyof ZulassungsantragFormData;
  required: boolean;
  pattern?: RegExp;
  minLength?: number;
  maxLength?: number;
  errorMessage: string;
}

export const VALIDATION_RULES: FormValidation[] = [
  // Geschäftsvorfall (obligatorisch)
  { field: 'geschaeftsvorfallTyp', required: true, errorMessage: 'Geschäftsvorfall-Typ ist erforderlich' },
  
  // Halterdaten (obligatorisch)
  { field: 'vorname', required: true, errorMessage: 'Vorname ist erforderlich' },
  { field: 'nachname', required: true, errorMessage: 'Nachname ist erforderlich' },
  { field: 'email', required: false, pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, errorMessage: 'Ungültige E-Mail-Adresse' },
  
  // Fahrzeugdaten (obligatorisch)
  { field: 'fin', required: true, minLength: 5, maxLength: 17, errorMessage: 'FIN muss zwischen 5 und 17 Zeichen lang sein' },
  { field: 'zbIINummer', required: true, errorMessage: 'ZB1 Nummer ist erforderlich' },
  { field: 'zbIISicherheitscode', required: true, errorMessage: 'Sicherheitscode ZB1 ist erforderlich' },
  
  // Bankverbindung (obligatorisch)
  { field: 'zulassungsstelle', required: true, errorMessage: 'Zulassungsstelle ist erforderlich' },
  { field: 'iban', required: true, pattern: /^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$/, errorMessage: 'Ungültige IBAN' },
  { field: 'bankName', required: true, errorMessage: 'Name des Kontoinhabers ist erforderlich' },
  
  // Versandadresse (obligatorisch)
  { field: 'versandName', required: true, errorMessage: 'Name für Versandadresse ist erforderlich' },
  { field: 'versandStrasse', required: true, errorMessage: 'Straße für Versandadresse ist erforderlich' },
  { field: 'versandHausnummer', required: true, errorMessage: 'Hausnummer für Versandadresse ist erforderlich' },
  { field: 'versandPostleitzahl', required: true, pattern: /^\d{5}$/, errorMessage: 'Postleitzahl muss 5 Ziffern haben' },
  { field: 'versandOrt', required: true, errorMessage: 'Ort für Versandadresse ist erforderlich' },
  
  // Kunde (obligatorisch)
  { field: 'kundeId', required: true, errorMessage: 'Kunde muss ausgewählt werden' },
  
  // Fakultative Felder mit Validierung
  { field: 'reservierungsPin', required: false, pattern: /^\d{4,8}$/, errorMessage: 'Reservierungs-PIN muss 4-8 Ziffern haben' },
  { field: 'huPruefziffer', required: false, pattern: /^\d{8}$/, errorMessage: 'HU-Prüfziffer muss 8 Ziffern haben' }
];
// Änderung um build zu starten